export { default } from './BottomText';
